import { useEffect, useState } from 'react';
import { ensure } from '../store/driversSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useModals } from '@mattjennings/react-modal-stack';
import { URL_PREFIX } from '../api';
import ImagePickerModal from '../components/ImagePickerModal';
import { DataContainer } from '../components/DataContainer';
import { fetch } from '../store/driversSlice';
import { toast } from 'react-toastify';
import { unwrapResult } from '@reduxjs/toolkit';
import { fetchUserAsync, resetPassword, updateUser } from '../store/userSlice';
import { toggleDriverHidden } from '../store/driversSlice';



function DriverModal({ open, id, isSelf = false }) {
    id = id.toUpperCase();
    const { closeModal, openModal } = useModals();
    const dispatch = useDispatch();

    const [ firstname, setFirstname ] = useState('');
    const [ phone, setPhone ] = useState('');
    const [ username, setUsername ] = useState('');
    const [ email, setEmail ] = useState('');
    const [ role, setRole ] = useState('driver');
    const [ hidden, setHidden ] = useState(false);

    const [ newPassword, setNewPassword ] = useState('');
    const [ newPasswordAgain, setNewPasswordAgain ] = useState('');
    const user = useSelector((state) => state.user.data);

    const _drivers = useSelector((state) => state.drivers.knownDrivers);

    const driver = isSelf ? user : ((id in _drivers) ? _drivers[id] : null);

    useEffect(() => {
        setFirstname(isSelf ? user["firstname"] : driver["driver_firstname"]);
        setPhone(isSelf ? user["phone"] : driver["driver_phone"]);
        setUsername(isSelf ? user["username"] : driver["driver_username"]);
        setEmail(isSelf ? user["email"] : driver["driver_email"]);
        setRole(isSelf ? user["role"] : driver["driver_role"]);
        setHidden(isSelf ? user["hidden"] : driver["driver_hidden"]);
    }, [ driver, user, isSelf ]);

    useEffect(() => {(async () => {
        console.log("Ensuring driver");
        await dispatch(ensure({ id }));
    })()}, []);

    async function onChangePassword() {
        if(newPassword != newPasswordAgain) {
            toast.error("Paroolid ei ühti");
            return;
        }

        if(newPassword.length < 1) {
            toast.error("Parool puudu");
            return;
        }

        try {
            const res = await unwrapResult(await dispatch(resetPassword({ id, password: newPassword })));

            closeModal();
            toast.success("Parool uuendatud!");
        } catch (e) {
            toast.error(e.message);
            console.log(e);
        }
    }

    async function onUpdateUser() {
        if(role == "driver" && (isSelf ? user["role"] : driver["driver_role"]) == "admin") {
            if(!window.confirm("Kas oled kindel, et soovid endalt administraator õigused eemaldada? Neid saab tagasi anda ainult teine administraator.")) return;
        }

        const res = await unwrapResult(await dispatch(updateUser({
            id,
            username,
            firstname,
            phone,
            email,
            role
        })));
        if(!res) return;

        closeModal();

        if(isSelf)  dispatch(fetchUserAsync());
        else        dispatch(fetch({ id }));

        toast.success("Andmed uuendatud!");
    }

    async function toggleHidden() {
        const wasHidden = hidden;
        const res = await unwrapResult(await dispatch(toggleDriverHidden({ id, hidden: !hidden })));
        if(!res) return;

        closeModal();

        if(isSelf)  dispatch(fetchUserAsync());
        else        dispatch(fetch({ id }));

        toast.success("Juht " + (wasHidden ? "nähtavaks tehtud!" : "peidetud!"));
    }

    if(!driver) return null;
    if (!open) return null;

    return (
        <div className='modal'>
            <div className='container column'>
                <DataContainer actionType={'drivers/ensure'} >
                    <div className="row g16 p16" style={{ alignItems: 'start' }}>
                        <div className="line g16 grow">
                            <img
                                src={URL_PREFIX + "/storage/driver/"+(isSelf ? user.id : driver.driver_id).toLowerCase()+".jpg"}
                                style={{ objectFit: 'cover', width: 64, height: 64, borderRadius: 32 }}
                            />
                            <div className="column g8">
                                <div className="column">
                                    <h2>{isSelf ? user.firstname : driver.driver_firstname}</h2>
                                    { user.role == "admin" && (
                                        <p>{isSelf ? user.username : driver.driver_username}</p>
                                    ) }
                                    { user.role == "admin" && (
                                        <p style={{color: '#888'}}>{isSelf ? user.email : driver.driver_email}</p>
                                    ) }
                                </div>
                                { user.role == "admin" && (
                                    <button onClick={() => openModal(ImagePickerModal, { title: (isSelf ? user.firstname : driver.driver_firstname), url: `/driver/${id}/photo`, callback: () => dispatch(fetch({ id })) })}>Muuda pilti</button>
                                ) }
                                { user.role == "admin" && (
                                    <button onClick={toggleHidden} style={hidden ? {} : { backgroundColor: '#d4635b', borderColor: '#f4837b', color: '#fff' }}>
                                        {hidden ? "Too tagasi" : "Peida"}
                                    </button>
                                ) }
                            </div>
                        </div>

                        <button
                            onClick={() => {
                                dispatch(fetch({ id }));
                                closeModal();
                            }}
                            style={{
                                padding: 8,
                            }}
                        >
                            <svg height="12" width="12" xmlns="http://www.w3.org/2000/svg" fill="#666" version="1.1" id="Capa_1" viewBox="0 0 490 490" >
                                <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490   489.292,457.678 277.331,245.004 489.292,32.337 "/>
                            </svg>
                        </button>
                    </div>

                    { user.role == "admin" && (
                        <>
                            <div className="hr"></div>

                            <DataContainer actionType={'user/update'}>

                                <div className="column p32 g16">

                                    <h3>Uuenda andmeid</h3>

                                    <div className="column g4">
                                        <b>Eesnimi</b>
                                        <input type="text" autocomplete="off" value={firstname} onChange={(e) => setFirstname(e.target.value)} />
                                    </div>

                                    <div className="column g4">
                                        <b>Telefon</b>
                                        <input type="text" autocomplete="off" value={phone} onChange={(e) => setPhone(e.target.value)} />
                                    </div>

                                    <div className="column g4">
                                        <b>Kasutajanimi</b>
                                        <input type="text" autocomplete="off" value={username} onChange={(e) => setUsername(e.target.value)} />
                                    </div>

                                    <div className="column g4">
                                        <b>E-post</b>
                                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>

                                    <div className="column g4">
                                        <b>Konto tüüp</b>
                                        <select value={role} onChange={(e) => setRole(e.target.value)}>
                                            <option value="driver">Juht</option>
                                            <option value="admin">Admin</option>
                                        </select>
                                    </div>

                                    <button onClick={onUpdateUser}>Salvesta</button>

                                </div>

                            </DataContainer>
                        </>
                    ) }

                    { user.role == "admin" && (
                        <>
                            <div className="hr"></div>

                            <DataContainer actionType={'user/resetPassword'}>

                                <div className="column p32 g16">

                                    <h3>Muuda parool</h3>

                                    <div className="column g4">
                                        <b>Uus parool</b>
                                        <input type="password" placeholder='Parool' value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                                        <input type="password" placeholder='Parool' value={newPasswordAgain} onChange={(e) => setNewPasswordAgain(e.target.value)} />
                                    </div>

                                    <button onClick={onChangePassword}>Muuda parool</button>

                                </div>

                            </DataContainer>
                        </>
                    ) }
                </DataContainer>
            </div>
        </div>
    );
}

export default DriverModal;